<script lang="ts">  
import { _ } from 'svelte-i18n';
</script>

<section>
  <div class="jumbotron jumbotron-fluid">
    <div class="container">
      <h1 class="slogan">
        {$_("Heading")}
      </h1>
    </div>
  </div>
  <div class="subtitle">
    <p class="p-0 m-0">
        {$_("Introduction")}
    </p>
    <div class="counter p-0 m-0">
      <p class="counter-number p-0 m-0">
        +<span>6.220</span>K
      </p>
      <p class="p-0 m-0">
        {$_("Label_total_km")}
      </p>
    </div>
  </div>
</section>

<style>
.jumbotron {
  background-image: url(/img/header.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 100%;
  height: 90vh;
}

.slogan {
  padding-top: 25vh;
  font-size: 4.5rem;
  font-weight: 700;
  color: #fff;
  font-family: "Muli", sans-serif;
  line-height: 1.1;
  width: 88%;
}

.container {
  max-width: 85vw;
  width: 85vw;
  padding: 0 100px;
}

.subtitle {
  background-color: #36469d;
  color: #fff;
  line-height: 1.8;
  width: 60vw;
  padding: 2rem 8vw 2rem 5rem;
  position: absolute;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 3rem;
  font-size: medium;
}

.counter-number {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 4.1rem;
}
</style>
